var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"key-fact gap-4"},[_c('span',{staticClass:"text-zinc-500 text-base"},[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('rich-text',{staticClass:"text-base font-semibold text-zinc-900",attrs:{"content":_vm.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }